// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as OptimizeLog$Showside from "./OptimizeLog.bs.js";
import * as WebapiUtils$Showside from "./WebapiUtils.bs.js";
import * as ShopifyAnalytics$Showside from "./ShopifyAnalytics.bs.js";
function getAltFunnelConfigId(param) {
  try {
    return Caml_option.nullable_to_opt(new URL(window.location.href).searchParams.get("QNConfigId__alt"));
  } catch (exn) {
    return;
  }
}
function isAltFunnel(param) {
  return Belt_Option.isSome(getAltFunnelConfigId(undefined));
}
function setupAltFunnelElement(element) {
  var configId = getAltFunnelConfigId(undefined);
  if (configId !== undefined) {
    element.setAttribute("data-config", configId);
    element.setAttribute("data-namespace", "alt");
    element.setAttribute("data-auto-namespace", "false");
  }
  return element;
}
function appendBottomBar(param) {
  var localhost = Belt_Option.isSome(Caml_option.nullable_to_opt(document.querySelector("script[src^=\"http://localhost:8787/optimize.js?id=\"]")));
  var production = Belt_Option.isSome(Caml_option.nullable_to_opt(document.querySelector("script[src^=\"https://embed.maker.co/optimize.js?id=\"]")));
  var host = localhost ? "http://localhost:6007" : production ? "https://showside.maker.co" : window.location.origin;
  var script = document.createElement("script");
  script.setAttribute("src", host + "/smartnav-v2.js");
  Belt_Option.forEach(WebapiUtils$Showside.$$Document.body(document), function (param) {
    param.appendChild(script);
  });
}
async function updateAltFunnelVariant(variant) {
  var variantValue = Belt_Option.mapWithDefault(variant.value, variant.targetId, function (v) {
    return v;
  });
  var variantIsProductAltFunnel = Belt_Option.getWithDefault(variantValue, "").includes("QNProductId__alt=...");
  var variantIsCollectionAltFunnel = Belt_Option.getWithDefault(variantValue, "").includes("QNView__alt=category%3A...");
  var match = Belt_Option.isSome(getAltFunnelConfigId(undefined));
  var match$1 = variantIsProductAltFunnel || variantIsCollectionAltFunnel;
  var variant$1 = match && match$1 ? (OptimizeLog$Showside.log2("already in alt funnel, skipping", {
    variant: variant.targetId,
    value: variantValue
  }), undefined) : variant;
  if (variantIsProductAltFunnel) {
    await ShopifyAnalytics$Showside.waitForShopifyAnalytics(undefined, undefined);
  } else if (variantIsCollectionAltFunnel) {
    await ShopifyAnalytics$Showside.waitForShopifyAnalytics(undefined, undefined);
  }
  var match$2 = ShopifyAnalytics$Showside.getProductPageProductId(undefined);
  var match$3 = ShopifyAnalytics$Showside.getCollectionPageCollectionId(undefined);
  var variant$2;
  if (variant$1 === undefined) {
    return variant$1;
  }
  var exit = 0;
  if (variantIsProductAltFunnel) {
    if (match$2 !== undefined) {
      OptimizeLog$Showside.log2("alt funnel matched", {
        variant: variant$1.targetId,
        value: variantValue,
        productId: match$2,
        variantId: ShopifyAnalytics$Showside.getProductPageVariantId(undefined)
      });
      var variantId = ShopifyAnalytics$Showside.getProductPageVariantId(undefined);
      var value = variantId !== undefined ? Belt_Option.map(variantValue, function (__x) {
        return __x.replace("QNProductId__alt=...", "QNProductId__alt=...&QNVariantId__alt=" + variantId + "");
      }) : variantValue;
      var value$1 = Belt_Option.map(value, function (__x) {
        return __x.replace("QNProductId__alt=...", "QNProductId__alt=" + match$2 + "");
      });
      return {
        targetId: variant$1.targetId,
        target: variant$1.target,
        value: value$1,
        targetType: variant$1.targetType,
        splitRange: variant$1.splitRange,
        createdAt: variant$1.createdAt,
        updatedAt: variant$1.updatedAt,
        trackingId: variant$1.trackingId
      };
    }
    exit = 2;
  } else {
    exit = 2;
  }
  if (exit === 2) {
    if (variantIsCollectionAltFunnel) {
      if (match$3 !== undefined) {
        OptimizeLog$Showside.log2("alt funnel matched", {
          variant: variant$1.targetId,
          value: variantValue,
          collectionId: match$3
        });
        var value$2 = Belt_Option.map(variantValue, function (__x) {
          return __x.replace("QNView__alt=category%3A...", "QNView__alt=category%3A" + match$3 + "");
        });
        return {
          targetId: variant$1.targetId,
          target: variant$1.target,
          value: value$2,
          targetType: variant$1.targetType,
          splitRange: variant$1.splitRange,
          createdAt: variant$1.createdAt,
          updatedAt: variant$1.updatedAt,
          trackingId: variant$1.trackingId
        };
      }
      variant$2 = variant$1;
    } else {
      if (!variantIsProductAltFunnel) {
        return variant$1;
      }
      variant$2 = variant$1;
    }
  }
  OptimizeLog$Showside.log2("alt funnel matched but Shopify product or collection ID not found", {
    variant: variant$2.targetId,
    value: variantValue
  });
}
export { getAltFunnelConfigId, isAltFunnel, setupAltFunnelElement, appendBottomBar, updateAltFunnelVariant };
/* WebapiUtils-Showside Not a pure module */